import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { Separator } from "@/components/ui/separator";
export default function IntroHeadlineOpeners() {
  const trustBadges = [{
    src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1667719/img/iso_certification_badge.png",
    alt: "ISO Certification",
    className: "h-12 md:h-16 object-contain"
  }, {
    src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1667719/img/global_trade_compliance.png",
    alt: "Global Trade Compliance",
    className: "h-16 md:h-24 object-contain"
  }, {
    src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1667719/img/sustainability_standard.png",
    alt: "Sustainability Standard",
    className: "h-12 md:h-16 object-contain"
  }];
  return <section data-section-id="253399" id="privacy-policy" className="bg-background py-20 text-foreground">
      <div className="page-container max-w-4xl mx-auto flex flex-col items-center text-center">
        {}
        <div className="w-12 h-px bg-primary/20 mb-8 self-start md:self-center"></div>

        {}
        <h2 className="text-3xl md:text-5xl font-bold text-foreground mb-10 font-default leading-tight">
          Oriental World Corporation Limited takes privacy seriously<br className="hidden md:block" /> and protects your data.
        </h2>

        {}
        <div className="space-y-6 text-muted-foreground text-base md:text-lg mb-12 max-w-3xl">
          <p className="font-default">
            This website may collect contact information submitted through inquiry forms to facilitate our global trading operations.
          </p>
          <p className="font-semibold text-foreground font-default">
            Information is used only for communication and business enquiries related to our industrial commodity trading services.
          </p>
          <p className="font-default">
            Oriental World Corporation Limited does not sell personal information to third parties, ensuring your corporate data remains confidential.
          </p>
          <p className="font-default">
            Users may contact the company regarding privacy-related requests or concerns at any time through our official channels.
          </p>
        </div>

        {}
        <div className="flex flex-col sm:flex-row gap-4 w-full max-w-2xl mx-auto mb-20">
          <Button variant="outline" className="flex-1 border-primary text-primary hover:bg-primary/5 h-12 text-base rounded-md shadow-sm" asChild>
            <Link to="/ContactPage">Contact Our Team</Link>
          </Button>
          <Button variant="outline" className="flex-1 border-primary text-primary hover:bg-primary/5 h-12 text-base rounded-md shadow-sm" asChild>
            <Link to="/AboutUsPage">About Our Standards</Link>
          </Button>
        </div>

        {}
        <div className="w-full flex flex-col items-center">
          <p className="text-muted-foreground text-lg mb-4 font-default">For privacy inquiries, contact info@owcl.com.hk</p>
          

          {}
          
        </div>
      </div>
    </section>;
}